import * as basicLightbox from 'basiclightbox';
import 'basiclightbox/dist/basicLightbox.min.css';

import { closeModal } from './closeModal';

function createModal(product) {
  const instance = basicLightbox.create(`
    <div class="modal">
      <img src="${product.img}" alt="${product.name}" width="200">
      <h2>${product.name}</h2>
      <h3>${product.price} грн</h3>
      <p>${product.description}</p>
      <div>
        <button class="js-favorite">Add to favorite</button>
        <button class="js-basket">Add to basket</button>
        <button class="js-close-modal">Close</button>
      </div>
    </div>`,
    {
     handler: null,
       onShow(instance) {
         this.handler = closeModal.bind(instance)
         document.addEventListener('keydown', this.handler);
         const closeButton = instance.element().querySelector('.js-close-modal');
        closeButton.addEventListener('click', () => {
          instance.close();
        });
         document.addEventListener('keydown', closeModal);
       },
       onClose() {
         document.removeEventListener('keydown', this.handler);
         document.removeEventListener('keydown', closeModal);
      
     },
  }
    // {
    //   onShow(instance) {
    //     const closeButton = instance.element().querySelector('.js-close-modal');
    //     closeButton.addEventListener('click', () => {
    //       instance.close();
    //     });

    //     document.addEventListener('keydown', closeModal);
    //   },
    //   onClose() {
    //     document.removeEventListener('keydown', closeModal);
    //   },
    // }
  );

  instance.show();
}

export { createModal };
